import { Any, List, Object } from 'ts-toolbelt';
import { PapiGqlGetUserQuery } from 'types/papi-graphql';

export interface IMenuClickevent {
  key: React.Key;
  keyPath: React.Key[];
  item: React.ReactInstance;
  domEvent: React.MouseEvent<HTMLElement>;
}

export type TSelectableActionInput = {
  selected?: any[];
  showSelected?: boolean;
  onClear?: React.MouseEventHandler<HTMLElement> | undefined;
  children?: any | null;
};

export type TBreadCrumb = {
  title: string;
  href?: string;
};

export type NonNullPath<O extends any, P extends List.List<Any.Key>> = NonNullable<
  Object.Path<O, P>
>;

export const notEmpty = <TValue>(value: TValue | null | undefined | false): value is TValue => {
  return value !== null && value !== undefined;
};

export type User = NonNullPath<PapiGqlGetUserQuery, ['user']>;
export type Customer = Omit<NonNullPath<User, ['customer']>, '__typename'>;
